import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ImageComponent } from './imageComponent';
import { ImageDimensionModule } from "../../utils/pipes";

export * from './imageComponent';

@NgModule({
  imports: [
    CommonModule,
    ImageDimensionModule
  ],
  declarations: [    
    ImageComponent
  ],
  exports: [
    ImageComponent
  ]
})
export class ImageModule {

}